import { render, staticRenderFns } from "./VArticlePreview.vue?vue&type=template&id=2fcd831d&"
import script from "./VArticlePreview.vue?vue&type=script&lang=js&"
export * from "./VArticlePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports